var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{ 'loader--visible': _vm.loading }},[_c('circle-8',{staticClass:"loader-element"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }